export function formatNumber(number) {
  return number.toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$&,');
}

export function getRandomNumber(min, max) {
  if (Number.isInteger(min) && Number.isInteger(max)) {
    // 如果两个数都是整数，生成介于min和max之间的随机整数
    return Math.floor(Math.random() * (max - min + 1)) + min;
  } else {
    // 如果两个数中有一个带有小数点，生成介于min和max之间的随机小数
    return (Math.random() * (max - min) + min).toFixed(2);
  }
}
